import React from 'react';
import { PortalContext } from '../../../../../context/portal-context';
import { formatOwnership } from '../../../../../tracking/tracking-helper';
import { useTrackingManager } from '../../../../../tracking/use-tracking-manager';
import { HuchaTier } from '../../shared/models/hucha-values';

const getHuchaIdentifier = (huchaTier: HuchaTier) => {
	switch (huchaTier) {
		case 'renovadorPlus15':
			return 'Renovadores +15 años';
		case 'renovador10To15':
			return 'Renovadores 10-15 años';
		case 'renovadorPlus10':
			return 'Renovadores +10 años';
		default:
			return 'Estándar';
	}
};

export const useHuchaTracker = (huchaTier: HuchaTier) => {
	const huchaTierIdentifier = getHuchaIdentifier(huchaTier);
	const sectionName = 'Hucha';
	const trackingManager = useTrackingManager();
	// User vehicles
	const { portalService } = React.useContext(PortalContext);
	const userVehicles = portalService.getPersonVehicles().getValue();

	const trackOpenLayerClick = () => {
		const openLayerClickCtaLabel = huchaTier == 'standard' ? 'Más sobre tus ahorros' : 'Aprovéchalos';
		const contentIdValue = `${sectionName} - ${huchaTierIdentifier} - Open Layer - ${openLayerClickCtaLabel}`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	const trackLayerLoad = React.useCallback(() => {
		trackingManager.trackClubVWLayerLoad(
			{ contentId: `${sectionName} - ${huchaTierIdentifier}` },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	}, [trackingManager, huchaTierIdentifier, userVehicles]);

	const trackLayerCloseClick = () => {
		const contentIdValue = `${sectionName} - ${huchaTierIdentifier}`;
		trackingManager.trackClubVWLayerCloseClick(contentIdValue, { contentId: contentIdValue });
	};

	const trackDownloadAhorroAcumulado = () => {
		const contentIdValue = `${sectionName} - ${huchaTierIdentifier} - Descargar ahorro acumulado`;
		trackingManager.trackClubVWDownloadClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	const trackCitaConcesionarioClick = () => {
		const contentIdValue = `${sectionName} - ${huchaTierIdentifier} - Pide cita en tu concesionario`;
		trackingManager.trackClubVWButtonClick(
			contentIdValue,
			{ contentId: contentIdValue },
			{ vehicle: formatOwnership(userVehicles?.vehicles) },
		);
	};

	return {
		trackOpenLayerClick,
		trackLayerLoad,
		trackLayerCloseClick,
		trackDownloadAhorroAcumulado,
		trackCitaConcesionarioClick,
	};
};
